<template>

  <v-dialog scrollable max-width="1200px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <v-icon :disabled="disabled" small v-on="on">edit</v-icon>
    </template>
    <v-card>
      <v-card-title>
        <h4>Actualizar bolsa principal</h4>
      </v-card-title>
      <v-card-text>
        <!-- <v-form ref="form">
        
            </v-form> -->

        <h3 v-if="bolsas.length == 0">Sin datos de bolsa principal</h3>

        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-right">IdBolsaDet</th>
                <th>Bolsa</th>
                <th>Rubro</th>
                <th class="text-right">Monto</th>
                <th>Accion</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="bolsa in bolsas" :key="bolsa.idBolsaPrincipalDet">
                <td class="text-right">{{ bolsa.idBolsaPrincipalDet }}</td>
                <td>{{ bolsa.bolsaDescripcion }}</td>
                <td>{{ bolsa.rubroDescripcion }}</td>
                <td class="text-right">{{ bolsa.importeBolsa | numberFormat }}</td>
                <td>
                  <v-layout>
                    <v-row align="center">
                      <v-btn small @click="confirmar(bolsa.idBolsaPrincipalDet)">SELECCIONAR</v-btn>
                    </v-row>
                  </v-layout>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>


      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>

      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import Vue from "vue";
import numeral from "numeral";
import axios from "axios";

export default Vue.extend({
  props: ["bolsaId", "bolsas", "disabled"],
  data() {
    return {
      loading: false,
      showDialog: false,
      nuevoMonto: 0,
      rules: {
        required: value => !!value || "Requerido.",
        counter: value => value.length <= 1000 || "Maximo 100 caracteres"
      },
      validForm: false
    };
  },
  mounted() {


  },
  methods: {
    close() {
      this.showDialog = false;
    },
    volver() {
      this.showDialog = false;
    },
    confirmar(idBolsaPrincipalDet) {

      axios
        .patch(`/bolsa/${this.bolsaId}/actualizarBolsaPrincipal/${idBolsaPrincipalDet}`)
        .then(response => {
          console.log(response);
          this.$emit('nuevoBolsaPrincipalDetalle', {bolsaId: this.bolsaId, bolsa: response.data});
          this.close();
        })
        .catch(err => {
          this.loading = false;
          this.nuevaCedula = this.cedula;
          console.log(err);
          this.errorMessage = "Error en la consulta";
        });
    }
  },
  filters: {
    numberFormat(value) {
      if (!isNaN(value)) {
        return numeral(+value).format("#,##0"); // displaying other groupings/separators is possible, look at the docs
      }
    },
  }
});
</script>